import { render, staticRenderFns } from "./Courseupload.vue?vue&type=template&id=66e99fd6&scoped=true&"
import script from "./Courseupload.vue?vue&type=script&lang=js&"
export * from "./Courseupload.vue?vue&type=script&lang=js&"
import style0 from "./Courseupload.vue?vue&type=style&index=0&id=66e99fd6&lang=scss&scoped=true&"
import style1 from "./Courseupload.vue?vue&type=style&index=1&id=66e99fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e99fd6",
  null
  
)

export default component.exports